import { LogManager, ModelRow, StringUtil } from "@mcleod/core";
import { RowDriverManagerProfileFields } from "../../../planning/src/models/autogen/AutogenModelDriverManagerProfile";
import { AutogenLayoutDriverManagerProfileFilter } from "./autogen/AutogenLayoutDriverManagerProfileFilter";

const log = LogManager.getLogger("lme.dispatch.planning.DriverManagerFilter");

export class DriverManagerProfileFilter extends AutogenLayoutDriverManagerProfileFilter{
}

export class DriverManagerFilter {
    private filterRow: ModelRow;
    private driverManagerList: string[];

    constructor(filterRow: ModelRow) {
        this.filterRow = filterRow;
        this.buildDriverManagerIncludeList();
        log.debug("Created filter", this);
    }

    buildDriverManagerIncludeList() {
        this.driverManagerList = this.tokenizeField("driver_managers", ",");
    }

    tokenizeField(field: keyof RowDriverManagerProfileFields, delimiter: string = ","): string[] {
        if (this.filterRow.isNull(field)) {
            return [];
        }
        const result = this.filterRow.get(field).split(delimiter);
        for (let i = 0; i < result.length; i++) {
            result[i] = result[i].trim();
        }
        return result;
    }

    dataPasses(data: ModelRow) {
        log.debug("Checking data", data);

        const activeStatus = this.filterRow.get("active_status");
        const showActive = ("A" === activeStatus);
        const showInactive = ("I" === activeStatus);
        const driverActive = data.getBoolean("driver1_active", false);
        // Exclude drivers without a manager based on filter
        if (data.isNull("driver1_manager")) {
            if(!this.filterRow.getBoolean("include_without_drv_mgr", false)) {
                return false;
            }
        }
        // Exclude active/inactive drivers based on filter
        else if ((showActive && !driverActive)
            || (showInactive && driverActive)) {
            return false;
        }
        // Exclude drivers whose manager is not included in the filter
        else if (!this.findItem(this.driverManagerList, data.get("driver1_manager"))) {
            return false;
        }

        if(!showActive || !showInactive) {
            if(driverActive && !showActive) {
                return false;
            }
            return driverActive || showInactive;
        }
        return true;
    }

    findItem(itemList: string[], item: string): boolean {
        if (itemList == null || itemList.length === 0 || "*" === itemList[0]) {
            return true;
        }

        if (StringUtil.isEmptyString(item)) {
            return false;
        }
        return itemList.indexOf(item) >= 0;
    }
}
